import styled from "styled-components";
import "./Input.css";
import { Controller } from "react-hook-form";
import { Colors } from "../colors/colors";










const { dangerColor } = Colors();

const InputComponent = ({
  placeholder,
  name,
  type,
  cName,
  id,
  onChange,
  style,
  value,
  hasLabel,
  label,
  errorText,
  control,
  ...rest
}) => {
  return (
    <InputComponentWrapper>
      <div className="d-flex flex-column w-100">
        {hasLabel && <label className="form-label">{label}</label>}

        <Controller
          rules={{ required: true }}
          name={name}
          control={control}
          defaultValue={value}
          render={({ field: { onChange, onBlur, ref } }) => (

            <input
              name={name}
              placeholder={placeholder}
              type={type}
              className={`input ${cName} gap-5`}
              id={id}
              onChange={onChange}
              style={{
                ...style,
                borderColor: errorText && dangerColor,
              }}
              defaultValue={value}
              {...rest}
              onBlur={onBlur}
              ref={ref}
            />

          )}
        />
      </div>

      {
        errorText && (
          <small
            style={{
              margin: 0,
              color: dangerColor,
            }}
          >
            {errorText || ""}
          </small>
        )
      }
    </InputComponentWrapper >
  );
};

export default InputComponent;


const InputComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-bottom: 1rem;
  width: -webkit-fill-available;
`;
